import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataManagementService {
  private readonly apiURLprefix : string = '/api/data-management';
  constructor(private http: HttpClient) {}

 /**
   * Database Migration call
   * 
   * @param host Target DB.
   */
  async syncDatabase(host: string): Promise<any> {
    return firstValueFrom(this.http.post<any>(`${this.apiURLprefix}/sync`, { host: host }));
  }

  getSyncStatus(): Promise<any> {
    return firstValueFrom(this.http.get<any>(`${this.apiURLprefix}/sync/status`));
  }

  async syncLocalizationDatabase(host: string): Promise<any> {
    return firstValueFrom(this.http.post<any>(`${this.apiURLprefix}/sync-localization`, { host }));
  }

  getLocalizationSyncStatus(): Promise<any> {
    return firstValueFrom(this.http.get<any>(`${this.apiURLprefix}/sync-localization/status`));
  }

  listRemoteLocalizationTables(): Promise<any> {
    return firstValueFrom(this.http.get<any>(`${this.apiURLprefix}/sync-localization/tables`));
  }

  syncLocalizationTablesToLocal(tables: string[]): Promise<any> {
    return firstValueFrom(this.http.post<any>(`${this.apiURLprefix}/sync-localization/local`, { tables }));
  }

  getLocalizationLocalSyncStatus(): Promise<any> {
    return firstValueFrom(this.http.get<any>(`${this.apiURLprefix}/sync-localization/local/status`));
  }
}